import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=bff7c150&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=bff7c150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff7c150",
  null
  
)

export default component.exports